import Peer from 'simple-peer';

export class FirebaseWebRTCApi {
  constructor({ conversation, localVideoRef, peerVideoRef }) {
    this.localVideoRef = localVideoRef;
    this.peerVideoRef = peerVideoRef;

    this.conversation = conversation;
    this.conversation.update({ answered: true });
  }

  initialize = async ({ callMode }) => {
    const mediaConstraints = {
      audio: true,
      video: (callMode === 'VIDEO' ? true : false),
    };
    const stream = this.stream = await navigator.mediaDevices.getUserMedia(mediaConstraints);

    this.peer = new Peer({
      trickle: true,
      config: {
        'iceServers': [
          { 'urls': 'stun:stun.services.mozilla.com' },
          { 'urls': 'stun:stun.l.google.com:19302' },
          { 'urls': 'turn:numb.viagenie.ca', 'credential': 'beaver', 'username': 'webrtc.websitebeaver@gmail.com' }
        ]
      }
    });

    this.localVideoRef.srcObject = stream;

    this.peer.on('signal', this._sendMessage);

    this.peer.on('stream', stream => { this.peerVideoRef.srcObject = stream });

    this.peer.on('track', (_track, stream) => { this.peerVideoRef.srcObject = stream });

    this.peer.on('close', () => {
      this.stream.getTracks().forEach(track => track.stop())
    });

    this.peer.on('error', (err) => {
      console.error('Peer error:', err)
    });

    this._listenOnConversation();
    this.peer.addStream(stream);
  }

  destroy = () => {
    this.stream.getTracks().forEach(track => track.stop());
    this.peer.destroy();
  }

  _sendMessage = message => {
    this.conversation.child('messages').push({ data: message, source: 'dashboard' });
  }

  _updateConversation = data => {
    this.conversation.update(data);
  }

  _listenOnConversation = () => {
    this.conversation.child('messages').on('child_added', snapshot => {
      const val = snapshot.val();
      if (val.source === 'client') {
        this.peer.signal(val.data);
      }
    });
  }
}
